<template>
  <main>
    <section class="title">
      <div class="title-wrapper">
        <h1>Développeur</h1>
      </div>
      <p class="subtitle">Miyuki CHERBAL — Développeur web</p>
    </section>

    <div class="devWrap">

      <div class="section-wrapper links-section">
        <h2>Profils</h2>
        <div class="linkList">
          <a href="https://github.com/iam-miyuki" target="_blank" rel="noopener noreferrer" class="profileLink">
            <span class="linkLabel">GitHub</span>
            <span class="linkUrl">github.com/iam-miyuki</span>
          </a>
          <a href="https://www.linkedin.com/in/miyuki-cherbal-b79887366" target="_blank" rel="noopener noreferrer" class="profileLink">
            <span class="linkLabel">LinkedIn</span>
            <span class="linkUrl">linkedin.com/in/miyuki-cherbal-b79887366</span>
          </a>
        </div>
      </div>

      <div class="section-wrapper stack-section">
        <h2>Stack technique</h2>
        <div class="stackGrid">
          <div class="stackItem">
            <span class="stackName">Vue 2</span>
            <span class="stackDesc">Framework JavaScript</span>
          </div>
          <div class="stackItem">
            <span class="stackName">Vue Router</span>
            <span class="stackDesc">Routing SPA</span>
          </div>
          <div class="stackItem">
            <span class="stackName">vue-i18n</span>
            <span class="stackDesc">Internationalisation FR / JA</span>
          </div>
          <div class="stackItem">
            <span class="stackName">SCSS</span>
            <span class="stackDesc">Styles modulaires avec variables</span>
          </div>
          <div class="stackItem">
            <span class="stackName">Vite</span>
            <span class="stackDesc">Build tool</span>
          </div>
          <div class="stackItem">
            <span class="stackName">vue-headful</span>
            <span class="stackDesc">Métadonnées SEO / OG</span>
          </div>
        </div>
      </div>

      <div class="section-wrapper project-section">
        <h2>Projet</h2>
        <p>Site officiel de l'<strong>ADLCJ</strong> (Association pour le Développement de la Langue et de la Culture Japonaises), association gérant l'école complémentaire japonaise de Lyon.</p>
        <p>Site bilingue français / japonais avec quiz de niveau interactif, pages dynamiques et design responsive.</p>
      </div>

    </div>
  </main>
</template>

<script>
export default {
  name: "Developpeur"
};
</script>

<style lang="scss" scoped>
.subtitle {
  font-size: 1rem;
  color: #555;
  margin-top: -0.5rem;
  margin-bottom: 2rem;
}

.devWrap {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 0 60px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.section-wrapper {
  text-align: left;
  padding: 1.25rem 1.5rem;

  h2 {
    margin: 0 0 1rem;
    font-size: 1.1rem;
    font-weight: 700;
    color: $accentColor;
  }
}

.linkList {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.profileLink {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
  text-decoration: none;
  color: inherit;

  &:hover .linkUrl {
    text-decoration: underline;
    color: $accentColor;
  }

  .linkLabel {
    font-weight: 700;
    min-width: 80px;
    font-size: 0.95rem;
  }

  .linkUrl {
    font-size: 0.9rem;
    color: $linkColor;
  }
}

.stackGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem 1.5rem;

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.stackItem {
  display: flex;
  flex-direction: column;
  gap: 2px;

  .stackName {
    font-weight: 700;
    font-size: 0.95rem;
  }

  .stackDesc {
    font-size: 0.8rem;
    color: #666;
  }
}

.project-section p {
  font-size: 0.95rem;
  margin: 0 0 0.5rem;
  line-height: 1.6;
}
</style>
